export default function Title({ text }) {
    return (
        <h3 className="esc-ii-uppercase esc-ii-font-bold esc-ii-mt-2.5 esc-ii-text-xl esc-ii-font-geometos lg:esc-ii-text-3xl">
            {text}
        </h3>
    );
}
